import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Injector,
  Input,
  OnInit,
} from '@angular/core';
import { Store } from '@sama/app-state';
import { DirectiveSuperclass } from '@sama/ng-core';
import { skip } from 'rxjs/operators';
import { DebouncedEventTracker } from '../../../cross-team-shared/event-tracking/debounced-event-tracker';
import { EventTrackingService } from '../../../shared/event-tracking/event-tracking.service';
import { SampleTask } from '../../../team-apis/otterdam/sample-task';
import { FeatureFlagService } from '../misc-services/feature-flag.service';

@Component({
  selector: 'h3-comment-editor',
  templateUrl: './comment-editor.component.html',
  styleUrl: './comment-editor.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CommentEditorComponent
  extends DirectiveSuperclass
  implements OnInit
{
  @Input({ required: true }) commentStore!: Store<string | null>;
  @Input({ required: true }) samplingStore: Store<SampleTask> | undefined;
  @Input() disable = false;

  displayWarningText = inject(FeatureFlagService).hasFlag('new-sampling-nav');
  private debouncedEventTracker: DebouncedEventTracker;

  constructor(eventTrackingService: EventTrackingService, injector: Injector) {
    super(injector);
    this.debouncedEventTracker = new DebouncedEventTracker(
      { id: 'edit_qa_comment', bucket: 'quality_feedback' },
      eventTrackingService,
    );
  }

  ngOnInit() {
    this.subscribeTo(this.commentStore.$.pipe(skip(1)), () => {
      this.debouncedEventTracker.trackWithDebounce({});
    });
  }
}
